<template>
  <b-modal :id="id" :title="orderItem && orderItem.id ? 'Editar Item' : 'Adicionar Item'">
    <template slot="default">
      <div v-if="saving" class="row justify-content-center">
        <div class="col-auto">
          <loading-animation/>
        </div>
      </div>

      <div v-else class="row">
        <div class="col-10">
          <label for="itemSelect">Selecione o Item:</label>
          <model-list-select
            id="itemSelect"
            :list="items"
            option-value="id"
            option-text="label"
            v-model="selectedItem"
            placeholder="Digite para pesquisar..."
            @searchchange="searchItem"
            :filterPredicate="alwaysTrueFilterPredicate"
          />
        </div>
        <div class="col-2">
          <div v-if="searchItemInProcess">
            <loading-animation/>
          </div>
        </div>

        <div class="col-sm-6 col-12 mt-3">
          <label for="quantityInput">Quantidade:</label>
          <b-input v-model="quantity" id="quantity" class="margin-right" onFocus="this.setSelectionRange(0, this.value.length)"></b-input>
        </div>
      </div>
    </template>

    <template slot="modal-footer" slot-scope="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">Cancelar</b-button>
      <b-button :disabled="saving" variant="success" @click="save()">Salvar</b-button>
    </template>
  </b-modal>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders'
  import { ModelListSelect } from 'vue-search-select'
  import { httpClient } from '@/service'
  import shared from '@/shared/shared'

  export default {
    name: 'order-item-form-modal',
    components: { LoadingAnimation, ModelListSelect },

    props: {
      order: {
        require,
        type: Object
      },
      saved: {
        type: Function
      }
    },

    data() {
      return {
        id: 'order-item-form-modal',
        orderItem: {},
        searchItemInProcess: false,
        items: [],
        selectedItem: {},
        quantity: '',
        itemSearchTimeout: null,
        saving: false
      }
    },

    mounted() {
      this.searchItem(null);
    },

    methods: {
      save() {
        if (!this.selectedItem || !this.selectedItem.id) {
          this.$notify.textError("Por favor selecione um item");
          return;
        }

        this.quantity = Number(this.quantity);

        if (!this.quantity || isNaN(this.quantity) || this.quantity <= 0) {
          this.$notify.textError("Por favor informe a quantidade");
          return;
        }

        if (!this.order.orderItems) {
          this.order.orderItems = [];
        }

        if (!this.orderItem) {
          this.orderItem = {};
        }

        if (this.order.orderItems.find(oi => oi.item && oi.item.id === this.selectedItem.id && (!this.orderItem.id || oi.id !== this.orderItem.id))) {
          this.$notify.textError("Esse item já foi adicionado ao pedido");
          return;
        }

        this.orderItem.order = { id: this.order.id };
        this.orderItem.item = this.selectedItem;
        this.orderItem.quantity = this.quantity;

        this.saving = true;
        let promise;
        if (this.orderItem.id) {
          promise = httpClient.put(`${process.env.VUE_APP_API_URL}order-items/`, this.orderItem)
        } else {
          promise = httpClient.post(`${process.env.VUE_APP_API_URL}order-items/`, this.orderItem);
        }

        promise.then(data => {
          this.saving = false;
          this.$notify.success('Item salvo com sucesso');
          this.$bvModal.hide(this.id);
          this.saved(data.data.data);
        }).catch(error => {
          this.saving = false;
          if (error.message) {
            this.$notify.error(error)
          } else {
            this.$notify.textError('Houve um erro ao salvar')
          }
        });
      },

      async searchItem (searchText) {
        if (!this.searchItemInProcess && (
          (searchText && searchText.length) || !this.selectedItem || Object.keys(this.selectedItem).length == 0
        )) {
          if (this.itemSearchTimeout) {
            clearTimeout(this.itemSearchTimeout);
          }

          this.itemSearchTimeout = setTimeout(() => {;
            this.searchItemInProcess = true

            if (searchText && searchText.length) {
              httpClient
              .post(`${process.env.VUE_APP_API_URL}items/condition?page=${0}&size=${10}`, {
                conditions: [
                  {
                    logicalOperator: 'OR',
                    conditions: [
                      {
                        field: 'description',
                        conditionalOperator: 'LIKE_START',
                        value: searchText
                      },
                      {
                        field: 'ref',
                        conditionalOperator: 'LIKE_END',
                        value: shared.mountReduzidoFilter(searchText)
                      },
                      {
                        field: 'sku',
                        conditionalOperator: 'LIKE',
                        value: searchText
                      },
                      {
                        field: 'gtin',
                        conditionalOperator: 'LIKE',
                        value: searchText
                      }
                    ]
                  }
                ]
              })
              .then(({ data }) => {
                this.items = this.handleData(data);
                this.setItemsLabel();
              })
              .catch((error) => {
                this.searchItemInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            } else {
              httpClient
              .get(`${process.env.VUE_APP_API_URL}items/?page=${0}&size=${10}`)
              .then(({ data }) => {
                this.items = this.handleData(data);
                this.setItemsLabel();
              })
              .catch((error) => {
                this.searchItemInProcess = false
                if (error.message) {
                  this.$notify.error(error)
                }
              });
            }
          }, 500);
        }
      },

      handleData(data) {
        this.searchItemInProcess = false
        this.totalRows = data.data.totalElements
        const items = data.data.content

        return items
      },

      open(orderItem) {
        this.orderItem = orderItem;

        if (this.orderItem) {
          this.selectedItem = this.orderItem.item;
          this.quantity = this.orderItem.quantity;
        } else {
          this.selectedItem = {};
          this.quantity = '';
        }

        this.$bvModal.show(this.id);
      },

      cancel() {
        this.$bvModal.hide(this.id);
      },

      getItemLabel(item) {
        return shared.getItemLabel(item);
      },

      setItemsLabel() {
        if (this.items && this.items.length) {
          this.items.forEach(item => {
            item.label = this.getItemLabel(item);
          });
        }
      },

      alwaysTrueFilterPredicate() {
        return true;
      },
    }
  };
</script>

<style scoped>
</style>
